<template>
  <v-text-field v-model="editorValue" ref="dateEditorField" :dense="dense" :disabled="disabled" :label="label" :outlined="outlined" :clearable="!required" append-icon="mdi-palette" @input="()=>{}" @keydown="onKeyDown" @click:append="visible=true" @blur="onBlur" @click:clear="onClear">

    <template v-slot:prepend-inner>
      <v-icon :color="editorValue">mdi-rectangle</v-icon>
      <v-menu :activator="$refs.dateEditorField" :open-on-click="false" v-model="visible" transition="scale-transition" :close-on-content-click="false" max-width="290">
        <v-color-picker v-model="pickerValue" @input="onPicked" mode="hexa"></v-color-picker>
      </v-menu>
    </template>
  </v-text-field>

</template>
<script>
import EditorProps from '../EditorProps';
export default {
  name: 'color-editor',
  props: { ...EditorProps.custom, ...EditorProps.vuetify },
  data () {
    return {
      visible: false,
      defaultPickerValue: '#FFFFFF',
      editorValue: this.value,
      pickerValue: this.value,
      oldValue: this.value
    }
  },
  watch: {
    visible (v1) {
      if (v1 === false) this.triggerChange();
      else this.pickerValue = this.pickerValue || this.defaultPickerValue;
    },
    value (v) {
      this.editorValue = v;
      this.pickerValue = v;
      this.oldValue = v;
    }
  },
  methods: {
    onBlur () {
      this.pickerValue = this.editorValue || this.defaultPickerValue;
      this.triggerChange();
    },
    onPicked () {
      this.editorValue = this.pickerValue;
      this.triggerChange();
    },
    onClear () {
      this.pickerValue = this.defaultPickerValue;
      this.editorValue = null;
      this.triggerChange();
    },
    onKeyDown (e) {
      let code = e.keyCode;
      if (code == 13) this.triggerChange()
    },

    triggerChange () {
      this.$emit('input', this.editorValue);
      this.$emit('change', this.editorValue);
      // this.$emit('change', this.editorValue, this.oldValue);
      // this.oldValue = this.editorValue;
    }
  }
}
</script>